export default __webpack_public_path__ + "static/thumb-15-9cf5146c1e71e9948f4f6273d6ebd9bd.jpg";